import { GridColDef } from '@mui/x-data-grid-pro';
import { BrokerCarrier } from '@api/Trinium/Endpoints/Broker/types';
import { ParsedDate } from '@api/Trinium/types';
import { caseInsensitiveIncludes } from '@components/DataGrid/Dispatch/columns';
import { DateAfterTodayOperator } from '../Filters';
import BrokerMobileItem from './BrokerMobileItem';

export const brokerCarrierColumnDefinitions: GridColDef<BrokerCarrier>[] = [
	{
		field: 'id',
		headerName: 'Code',
		minWidth: 100,
		sortable: false,
		disableReorder: true
	},
	{
		field: 'name',
		headerName: 'Name',
		flex: 1,
		sortable: false,
		disableReorder: true
	},
	{
		field: 'liabInsAmt',
		headerName: 'Liab. Ins. Amt',
		minWidth: 125,
		align: 'right',
		sortable: false,
		disableReorder: true,
		renderCell: ({ row }) => <span>{`$ ${row.liabInsAmt?.toLocaleString() ?? '0.00'}`}</span>
	},
	{
		field: 'liabInsExpirationDate',
		headerName: 'Liab. Ins. Exp',
		minWidth: 125,
		align: 'center',
		sortable: false,
		disableReorder: true,
		renderCell: ({ row }) => <span>{row.liabInsExpirationDate?.date ?? 'N/A'}</span>,
		valueGetter: (value?: ParsedDate) => {
			return value?.date;
		},
		filterOperators: [DateAfterTodayOperator]
	},
	{
		field: 'cargoInsAmt',
		headerName: 'Cargo Ins. Amt',
		minWidth: 125,
		align: 'right',
		sortable: false,
		disableReorder: true,
		renderCell: ({ row }) => <span>{`$ ${row.cargoInsAmt?.toLocaleString() ?? '0.00'}`}</span>
	},
	{
		field: 'cargoInsExpriationDate',
		headerName: 'Cargo Ins. Exp',
		minWidth: 125,
		align: 'center',
		sortable: false,
		disableReorder: true,
		renderCell: ({ row }) => <span>{row.cargoInsExpriationDate?.date ?? 'N/A'}</span>,
		valueGetter: (value?: ParsedDate) => {
			return value?.date;
		},
		filterOperators: [DateAfterTodayOperator]
	}
];

export const brokerMobileColumnDefinitions: GridColDef<BrokerCarrier>[] = [
	{
		field: 'Mobile Card',
		flex: 1,
		renderCell: ({ row }) => <BrokerMobileItem broker={row} />,
		getApplyQuickFilterFn: (value: string) => {
			return (_, row): boolean => {
				const { id, name } = row;
				const searchableFields = [id, name];
				return caseInsensitiveIncludes(value, searchableFields);
			};
		}
	}
];
